
import React, { useState, useEffect } from "react";
import Title from "../home/Title";
import { FiSend } from "react-icons/fi";
import emailjs from "@emailjs/browser";

const Contact = () => {
    const [clientName, setClientName] = useState("");
    const [email, setEmail] = useState("");
    const [messages, setMessages] = useState("");
    const [errClientName, setErrClientName] = useState(false);
    const [errEmail, setErrEmail] = useState(false);
    const [errMessages, setErrMessage] = useState(false);
    const [seuccessMsg, setSuccessMsg] = useState("");
    const EmailValidation = (email) => {
        return String(email);
    };

    const handleName = (e) => {
        setClientName(e.target.value);
        setErrClientName(false);
    };
    const handleEmail = (e) => {
        setEmail(e.target.value);
        setErrEmail(false);
    };
    const handleMessages = (e) => {
        setMessages(e.target.value);
        setErrMessage(false);
    };

    useEffect(() => emailjs.init("7iGqIq1YprQp33Trt"), []);
    const handleSend = async (e) => {
        e.preventDefault();
        if (!clientName) {
            setErrClientName(true);
        }
        if (!email) {
            setErrEmail(true);
        } else {
            if (!EmailValidation(email)) {
                setErrEmail(true);
            }
        }
        if (!messages) {
            setErrMessage(true);
        }
        if (clientName && email && EmailValidation(email) && messages) {
            const serviceId = "service_alq8u9e";
            const templateId = "template_w79be2g";
            const params = {
                from_name: clientName,
                email_id: email,
                message: messages,
            }
            await emailjs.send(serviceId, templateId, params);
            setSuccessMsg(
                `Hello dear ${clientName}, Your messages has been sent successfully. Thank you for your time! ✅`
            );
            setClientName("");
            setEmail("");
            setMessages("");
        }
    };
    return (
        <div>
            <Title title="Get" subTitle="in Touch" />
            <div className="p-6 w-full flex flex-col md:flex-col justify-between gap-4 md:gap-10 lgl:gap-20">
                <div className="w-full lgl:w-full ">
                    <p className="flex-col gap-6 text-end w-full text-lg text-[#ccc] py-4 border-b-[1px] border-b-zinc-800">
                        <span className="w-max bg-designColor text-gray-700 text-sm font-titleFont font-medium px-2 mb-2  rounded-md flex items-center justify-center">
                            Address:
                        </span>
                        Karachi, Pakistan
                    </p>
                    <p className="flex-col gap-6 text-end w-full text-lg text-[#ccc] py-4 border-b-[1px] border-b-zinc-800">
                        <span className="w-max bg-designColor text-gray-700 text-sm font-titleFont font-medium px-2 mb-2 rounded-md flex items-center justify-center">
                            Phone:
                        </span>
                        +92 3423235676
                    </p>

                    <p className="flex-col gap-6 text-end w-full text-lg text-[#ccc] py-4 border-b-[1px] border-b-zinc-800">
                        <span className="w-max bg-designColor text-gray-700 text-sm font-titleFont font-medium px-2 mb-2 rounded-md flex items-center justify-center">
                            Email:
                        </span>
                        zakawatabbas123@gmail.com
                    </p>
                    <p className="flex-col gap-6 text-end w-full text-lg text-[#ccc] py-4 border-b-[1px] border-b-zinc-800">
                        <span className="w-max bg-designColor text-gray-700 text-sm font-titleFont font-medium px-2 mb-2 rounded-md flex items-center justify-center">
                            Freelance:
                        </span>
                        Available
                    </p>
                </div>
            </div>
            <div className="w-full">
                <Title title="Send" subTitle="Messages" />
                {seuccessMsg ? (
                    <p className="text-center text-base font-titleFont p-20 text-designColor">
                        {seuccessMsg}
                    </p>
                ) : (
                    <form
                        id="form"
                        action="https://getform.io/f/e18ee560-5133-4cfe-9a48-eddb6f012a9f"
                        method="POST"
                        className="p-6 flex flex-col gap-6"
                    >
                        <input
                            onChange={handleName}
                            value={clientName}
                            className={`${errClientName
                                ? "border-red-600 focus-visible:border-red-600"
                                : "border-zinc-600 focus-visible:border-designColor"
                                } w-full bg-transparent border-2 px-4 py-2 text-base text-gray-200 outline-none duration-300`}
                            type="text"
                            placeholder="Full Name"
                        />
                        <input
                            onChange={handleEmail}
                            value={email}
                            className={`${errEmail
                                ? "border-red-600 focus-visible:border-red-600"
                                : "border-zinc-600 focus-visible:border-designColor"
                                } w-full bg-transparent border-2 px-4 py-2 text-base text-gray-200 outline-none duration-300`}
                            type="email"
                            placeholder="Email Address"
                        />
                        <textarea
                            onChange={handleMessages}
                            value={messages}
                            className={`${errMessages
                                ? "border-red-600 focus-visible:border-red-600"
                                : "border-zinc-600 focus-visible:border-designColor"
                                } w-full bg-transparent border-2 px-4 py-2 text-base text-gray-200 outline-none duration-300 resize-none`}
                            placeholder="Your Message"
                            rows="4"
                        ></textarea>
                        <button
                            onClick={handleSend}
                            className="text-base uppercase font-semibold w-44 flex justify-center items-center self-center bg-designColor gap-1 text-gray-700 hover:bg-buttonHover duration-200 py-2 px-4 rounded-full"
                        >
                            Send Message{" "}
                            <span className=" text-gray-700 ">
                                <FiSend />
                            </span>
                        </button>
                    </form>
                )}
            </div>
        </div>
    );
};

export default Contact;

